const Loading = ({lang}) => {
     return (
       <div className="opacity-95 absolute bottom-0 left-0 flex items-center justify-center place-items-center h-screen text-base text-slate-200 font-base w-screen min-h-screen z-[100]">
         <div className="bg-white dark:bg-slate-700 px-12 py-4 rounded-full flex items-center justify-center">
         <div className="loader bg-slate-200 dark:bg-white mr-2"></div>
        <span className="font-inter">{lang === 'fr' ? 'Chargement' : 'Loading'}</span>
  </div>
  </div>


  
     );
   };
   
   export default Loading
   